import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'react-switch-lang';
import { observer } from 'mobx-react';
import DeleteButton from '../../components/buttons/DeleteButton';
import usersStorage from './usersStorage';
import RestoreButton from '../../components/buttons/RestoreButton';
import LockedButton from '../../components/buttons/LockedButton';
import UnlockedButton from '../../components/buttons/UnlockedButton';
import EditButton from '../../components/buttons/EditButton';

function UserActionsButton({ row, index }) {
  return (
    <div className="users-table_action-group btn-group">
      {!row.deleted_at
      && (
      <DeleteButton
        onClick={() => usersStorage.deleteUser(row.id)}
        id={`users-delete-button-${row.id}`}
        text={t('users.Delete')}
      />
      )}
      {row.deleted_at
      && (
      <RestoreButton
        onClick={() => usersStorage.restoreUser(row.id)}
        id={`users-restore-button-${row.id}`}
        text={t('users.Restore')}
      />
      )}
      {usersStorage.users[index].status == -1
      && (
      <LockedButton
        onClick={() => usersStorage.unbanUser(row.id)}
        id={`users-locked-button-${row.id}`}
        text={t('users.User locked, unlock it')}
      />
      )}
      {usersStorage.users[index].status !== -1
      && (
      <UnlockedButton
        onClick={() => usersStorage.banUser(row.id)}
        id={`users-unlocked-button-${row.id}`}
        text={t('users.User unlocked, Lock it!')}
      />
      )}
      <EditButton
        onClick={() => {
          usersStorage.setCurrentUser(row.id);
        }}
        id={`users-edit-button-${row.id}`}
        text={t('users.View user details')}
      />
    </div>
  );
}

UserActionsButton.propTypes = {
  row: PropTypes.object.isRequired,
};

export default observer(UserActionsButton);
